var visit = require('unist-util-visit');

var _require = require('@mdx-js/util'),
    isComment = _require.isComment,
    getCommentContents = _require.getCommentContents;

module.exports = function (_options) {
  return function (tree) {
    visit(tree, 'jsx', function (node) {
      if (isComment(node.value)) {
        node.type = 'comment';
        node.value = getCommentContents(node.value);
      }
    });
    return tree;
  };
};